<template>
	<div class="w-[50vw] h-[80vh] bg-white px-[40px] pt-[4%] box-border top-[50%] left-[50%] absolute"
		style="transform: translate(-50%,-50%);">
		<div class="text-[20px] font-bold text-[#1B2128] mb-[26px]">
			<label v-if="mode==1">{{langInfo.study_exercise_chapter}}</label>
			<label v-else-if="mode==2">{{langInfo.study_collect_start}}</label>
			<label v-else-if="mode==3">{{langInfo.study_wrong_start}}</label>
		</div>
		<div class="leading-[32px] text-[16px] text-[#686C73] mb-[60px]">
			{{langInfo.study_exercise_chapter_name}}: {{paperInfo.chapter_name||'' +'->'+ paperInfo.chapter_desc||''}}
			<br />
			{{langInfo.study_exercise_class_name}}: {{paperInfo.course_name||''}}<br />

			<div class="" v-if="mode==1">
				{{langInfo.study_exercise_total}}: {{paperInfo.question_count}}
				{{langInfo.study_paper_count||''}}<br />
				{{langInfo.study_exercise_pass}}: {{paperInfo.done_question_count}}
				{{langInfo.study_paper_count||''}}<br />
				{{langInfo.study_exercise_remain}}: {{paperInfo.remain_question_count}} {{langInfo.study_paper_count||''}}<br />
			</div>
			<div class="" v-else-if="mode==2">
				{{langInfo.collect_num}}: {{paperInfo.user_collection_count}}
				{{langInfo.study_paper_count||''}}<br />
			</div>
			<div class="" v-else-if="mode==3">
				{{langInfo.wrong_questions_number}}: {{paperInfo.question_userwrong_count}}
				{{langInfo.study_paper_count}}<br />
			</div>
		</div>
		<div class="text-[16px] text-[#686C73] mb-[10px]" v-if="mode==1">
			{{langInfo.study_exercise_title}}：
		</div>
		<div class="text-[12px] text-[#FF0000] leading-[30px] mb-[48px]" v-if="mode==1">
			1、{{langInfo.study_exercise_remark1}}<br />

			2、{{langInfo.study_exercise_remark2}}<br />

		</div>
		<div @click="startExercises()" v-if="isFinish"
			class="w-[200px] h-[40px]  cursor-pointer leading-[40px] mx-auto rounded-[6px] text-center text-white text-[16px] bg-[#68C340]">
			{{langInfo.study_exercise_start}}
		</div>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	export default {
		data() {
			return {
				mode: '', //1章节练习   2收藏练习  3错题练习
				id: '',
				paperInfo: {
					chapter_name: '',
					chapter_desc: ''
				},
				type: '', //sele章节练习  userwrong错题练习  collect收藏练习
				langInfo: {},
				isFinish: false,

			}
		},
		mounted() {
			EventBus.$on('reportContinue', (res) => {
				console.log("res========");
				console.log(res);
				this.isFinish = false
				this.getQuestionPaper()
			})

			this.id = this.$route.query.id;
			this.mode = this.$route.query.mode;
			this.order_item_id = this.$route.query.order_item_id;
			this.isFinish = false


			if (this.mode == 1) {
				this.type = 'sele'
			} else if (this.mode == 2) {
				this.type = 'collect'
			} else if (this.mode == 3) {
				this.type = 'userwrong'
			}
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

			this.getQuestionPaper()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionPaper() {
				this.$api.getQuestionPaper({
					small_id: this.id,
					order_item_id: this.order_item_id
				}).then((res) => {
					console.log(res);
					this.paperInfo = res.data
					this.isFinish = true

					document.title = this.paperInfo.chapter_name + '->' + this.paperInfo.chapter_desc


				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 开始练习
			startExercises() {

				if (this.type == 'sele' && this.paperInfo.remain_question_count <= 0) {
					this.$message({
						message: this.langInfo.impossible_continue_practicing,
						type: 'warning'
					})
					return
				}
				this.$router.push({
					path: 'chapterExam',
					query: {
						order_item_id: this.order_item_id,
						small_id: this.id,
						type: this.type,
						identification: this.paperInfo.identification
					}
				})
			},
		}
	}
</script>

<style>
</style>